import { z } from 'zod';
import { USER_ROLES, type UserRole } from '../enums';
import type { Permission } from '../permissions';
import { requiredText } from './common';

export const PASSWORD_MIN_LENGTH = 8;

export const passwordSchema = z
  .string({ error: 'Campo obligatorio' })
  .min(PASSWORD_MIN_LENGTH, `Mínimo ${PASSWORD_MIN_LENGTH} caracteres`)
  .max(200);

export const usernameSchema = z
  .string({ error: 'Campo obligatorio' })
  .trim()
  .toLowerCase()
  .min(3, 'Mínimo 3 caracteres')
  .max(50)
  .regex(/^[a-z0-9._-]+$/, 'Solo letras, números, punto, guion y guion bajo');

export const loginSchema = z.object({
  username: z.string().trim().toLowerCase().min(1, 'Introduzca el usuario').max(50),
  password: z.string().min(1, 'Introduzca la contraseña').max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const changeOwnPasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Campo obligatorio'),
  newPassword: passwordSchema,
});
export type ChangeOwnPasswordInput = z.infer<typeof changeOwnPasswordSchema>;

export const createUserSchema = z.object({
  username: usernameSchema,
  fullName: requiredText(120),
  role: z.enum(USER_ROLES),
  password: passwordSchema,
});
export type CreateUserInput = z.infer<typeof createUserSchema>;

export const updateUserSchema = z.object({
  fullName: requiredText(120),
  role: z.enum(USER_ROLES),
  active: z.boolean(),
});
export type UpdateUserInput = z.infer<typeof updateUserSchema>;

export const resetPasswordSchema = z.object({
  password: passwordSchema,
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export interface SessionUser {
  id: number;
  username: string;
  fullName: string;
  role: UserRole;
  permissions: Permission[];
}

export interface UserDto {
  id: number;
  username: string;
  fullName: string;
  role: UserRole;
  active: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}
